import React from "react";
//import "./LargeTextComponent.css";
import Paragraph from "./Paragraph";

const LargeTextComponent = ({ text, align }) => {
  return (
    <>
      <div className="ltcContainer">
        <h2 style={{ textAlign: align }}>
          <Paragraph text={text} />
        </h2>
      </div>

      <style jsx>{`
        .ltcContainer {
          width: 100%;
          background: black;
        }
        .ltcContainer h2 {
          margin: auto;
          font-family: Neue Montreal, -apple-system, Roboto, Helvetica,
            sans-serif;
          padding: 2em 1em;
        }

        @media (max-width: 768px) {
          .ltcContainer h2 {
            font-size: 2rem;
          }
        }
      `}</style>
    </>
  );
};

export default LargeTextComponent;
